export const getError = (state) => state.error;
export const getSuccess = (state) => state.success;
export const getIsLoading = (state) => state.isLoading;
export const getDataItem = (state) => state.dataItem;
export default {
    getError,
    getIsLoading,
    getDataItem,
    getSuccess,
};
